import { useState, useRef, Suspense, useCallback, useEffect, useContext } from "react";
import useRouteParam from "../../../../../../../../hooks/useRouteParam";
import { api } from "../../../../../../../../utils/api";
import { ThemeContext } from "../../../../../../../../contexts";

import { Backdrop, makeStyles } from "@material-ui/core";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import PublishIcon from "@material-ui/icons/Publish";
import { useReactToPrint } from "react-to-print";

import GLIFormActual from "./GLIFormActual/GLIFormActual";
import GLIFormPrint from "./GLIFormPrint/GLIFormPrint";

import "./gliForm.css";
import { trackPromise } from "react-promise-tracker";
import { AdminEnrollmentInitDataQuery } from "../../../../../../../../utils/api/pages/enrollmentInit";
import { Enrollment } from "../../../../../../../../@types/enrollment.types";

// eslint-disable-next-line arrow-parens
const useStyles = makeStyles((theme) => ({
	root: {
		height: 380,
		transform: "translateZ(0px)",
		flexGrow: 1
	},
	alert: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2)
		}
	},
	speedDial: {
		position: "fixed",
		bottom: theme.spacing(2),
		right: theme.spacing(2)
	}
}));

const GLIFormV2 = () => {
	const [openSpeedDial, setOpenSpeedDial] = useState(false);
	const { setTheme } = useContext(ThemeContext);
	const classes = useStyles();
	const componentRef = useRef(null);
	const queryGroupNumber = useRouteParam("gn");
	const queryPlanCode = useRouteParam("pc");
	const querySSN = useRouteParam("qs");
	const [enrollments, setEnrollments] = useState<Enrollment[]>([]);
	const [enrollmentStatus, setEnrollmentStatus] = useState<string>("");
	const [enrollmentDate, setEnrollmentDate] = useState<string>("");
	const [effectiveDate, setEffectiveDate] = useState<string>("");
	const [planName, setPlanName] = useState<string>("");

	const handlePrint = useReactToPrint({
		content: () => componentRef.current
	});
	const handleOpenSpeedDial = () => setOpenSpeedDial(true);

	const handleCloseSpeedDial = () => setOpenSpeedDial(false);
	const speedDialActions = [
		{
			icon: <SaveAltIcon />,
			name: "Download",
			callback: handlePrint
		},
		{
			icon: <PublishIcon />,
			name: "Submit"
		}
	];

	// eslint-disable-next-line arrow-parens
	const handleApproveEffectiveDateChange = useCallback((_date: string | Date) => {
		const date = new Date(_date);
		const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
		setEffectiveDate(parsedDate);
	}, []);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
			return;
		}

		const query: AdminEnrollmentInitDataQuery = {
			insured_SSN: querySSN as string,
			plan_code: queryPlanCode as string,
			group_number: queryGroupNumber as number,
			enrollment_status: "ACTIVE"
		};
		const { enrollments, theme } = await trackPromise(api.pages.getAdminEnrollmentInitData(query));
		setEnrollments(Object.assign([], enrollments[0]));
		const { enrollment_status, enrollment_date, plan_name } = enrollments[0];
		setTheme(Object.assign({}, theme));
		setEnrollmentDate(enrollment_date as unknown as string);
		setPlanName(plan_name);
		setEnrollmentStatus(enrollment_status);
	}, [queryGroupNumber, queryPlanCode, querySSN, setTheme]);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	// console.log("enrollments && enrollments[0]", enrollments);

	return (
		<div className="gli-form-container">
			<Backdrop open={openSpeedDial} style={{ zIndex: 1009 }} />
			<SpeedDial
				ariaLabel="SpeedDial"
				className={` ${classes.speedDial}`}
				icon={<SpeedDialIcon />}
				style={{ position: "fixed", bottom: 16, right: 16 }}
				onClose={handleCloseSpeedDial}
				onOpen={handleOpenSpeedDial}
				open={openSpeedDial}
				FabProps={{
					style: {
						backgroundColor: "green"
					},
					// eslint-disable-next-line arrow-parens
					onMouseOver: (event) => (event.currentTarget.style.backgroundColor = "secondary.main"),
					// eslint-disable-next-line arrow-parens
					onMouseOut: (event) => (event.currentTarget.style.backgroundColor = "green")
				}}
			>
				{speedDialActions.map((action, index) => {
					const { name, icon, callback } = action;
					return (
						<SpeedDialAction key={index} icon={icon} tooltipTitle={name} tooltipOpen onClick={callback} />
					);
				})}
			</SpeedDial>
			{enrollments ? (
				<>
					<GLIFormActual
						isPrintable={false}
						enrollments={enrollments}
						enrollmentDate={enrollmentDate}
						enrollmentStatus={enrollmentStatus}
						effectiveDate={effectiveDate}
						handleApproveEffectiveDateChange={handleApproveEffectiveDateChange}
						planName={planName}
					/>
					<div style={{ display: "none" }}>
						<Suspense fallback={<div />}>
							<GLIFormPrint
								ref={componentRef}
								enrollments={enrollments}
								// primaryBeneficiery={primaryBeneficiery}
								// contingentBeneficiery={contingentBeneficiery}
								enrollmentDate={enrollmentDate}
							/>
						</Suspense>
					</div>
				</>
			) : null}
		</div>
	);
};

export default GLIFormV2;
